import App from 'app/app.js';

function LtConfirmRedirectDirective() {
  return {
    restrict: 'E',
    scope: {
      changeConfirmationMessage: '@',
      changeConfirmationDescription: '@',
      confirmationButtonText: '@',
      cancellationButtonText: '@',
      close: '&',
      redirect: '&'
    },
    template:
      '    <div class="modal-body">' +
      '        <div>' +
      '           <div class="row">' +
      '               <div class="col-xs-12 text-center">' +
      '                   <lt-icon name="fa-solid-trash"></lt-icon>' +
      '               </div>' +
      '           </div>' +
      '           <div class="row">' +
      '               <div class="col-xs-12 text-center">' +
      '                   <b lt-translate="{{changeConfirmationMessage}}"></b>' +
      '               </div>' +
      '           </div>' +
      '           <div class="row" ng-show="!!changeConfirmationDescription">' +
      '               <div class="text-center summary-top col-xs-12">' +
      '                   <div lt-translate="{{changeConfirmationDescription}}"></div>' +
      '               </div>' +
      '           </div>' +
      '           <div class="row">' +
      '               <div class="col-xs-12">' +
      '                   <a ng-click="redirect()" lt-translate="{{ confirmationButtonText }}" class="btn blue text-wrap" ></a></span>' +
      '               </div>' +
      '           </div>' +
      '           <div align="center" class="row cancel-link-pad">' +
      '               <div class="text-center">' +
      '                   <a ng-click="close()"  class="col-xs-12" lt-translate="{{ cancellationButtonText }}" data-test-cancel-redirect></a></span>' +
      '               </div>' +
      '           </div>' +
      '        </div>' +
      '    </div>'
  };
}

App.directive('ltConfirmRedirect', [LtConfirmRedirectDirective]);
